import { safeGet, baseUrl } from './http'

export const getDataStreamAllowedDomains = () =>
  safeGet(`${baseUrl}/data-stream-allowed-domains/`)

export const getGraphicsURL = (): string => window.location.href.split('#')[0]
